module.exports = __webpack_public_path__ + "ab99809e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/logo.svg
// module id = 647
// module chunks = 0 1 2 3 4 5